export default "__VITE_ASSET__BPWO3dSa__"